import { createContext, useContext, useMemo } from 'react';
import { formatExact } from '../lib/currency.js';
import { useStoreConfig } from './StoreConfigContext.jsx';

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const { currency: serverConfig } = useStoreConfig();
  const value = useMemo(() => ({
    formatExact: (amount, code = serverConfig.base) => formatExact(amount, code, serverConfig),
    formatPrice: (amount, currency = serverConfig.base) => formatExact(amount, currency, serverConfig),
  }), [serverConfig]);

  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
}

export function useCurrency() {
  const context = useContext(CurrencyContext);

  if (!context) {
    throw new Error('useCurrency must be used inside a CurrencyProvider');
  }

  return context;
}
